import React, { FC } from 'react'
import { Container, Box, Stack, Text } from '@chakra-ui/react'

interface Props {
  title: string
  description: string
  asHtml?: boolean
}

const NltContentInfo: FC<Props> = ({ title, description, asHtml }) => {
  return <Box bg="white">
    <Container as={Stack} maxW="6xl" py={10}>
      <Text
        as="h3"
        align="left"
        color="baseDark"
        fontFamily="Montserrat-SemiBold"
        fontSize="1.375rem"
        letterSpacing="0.6px"
        lineHeight="26px"
        whiteSpace="pre-wrap"
      >
        {title}
      </Text>
      {asHtml ?
        <Box
          textAlign="left"
          color="baseNeutral.700"
          fontFamily="Montserrat-Medium"
          fontSize="1rem"
          letterSpacing="0.2px"
          whiteSpace="pre-wrap"
          pb="l"
          className="landing-text"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        :
        <Box
          textAlign="left"
          color="baseNeutral.700"
          fontFamily="Montserrat-Medium"
          fontSize="1rem"
          letterSpacing="0.2px"
          whiteSpace="pre-wrap"
          mt="m"
          pb="l"
        >
          {description}
        </Box>
      }
    </Container>
  </Box>
}

export default NltContentInfo
